import { AppEnvironment } from '@seb/web-common/core/models/environment.model';
import { version } from '../../../../package.json';

export const environment: AppEnvironment = {
  production: true,
  appVersion: version,
  disableTagCommander: false
};
